import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material";

interface PingIconProps {
  children?: React.ReactNode;
}

const PinIcon: React.FC<PingIconProps> = () => {
  const theme = useTheme();
  return (
    <SvgIcon
      sx={{
        fontSize: theme.spacing(2),
        marginRight: theme.spacing(1),
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="pin"
        data-name="pin"
        color={theme.palette.primary.main}
        viewBox="0 0 64 64"
      >
        <path d="m54.6 21.118-11.801-11.8c-1.863-1.863-4.896-1.863-6.762 0-2.592 2.593-3.959 6.094-3.831 9.731l-3.264 3.264c-5.301-1.551-11.065-.69-15.661 2.392-1.157.776-1.898 2.025-2.036 3.428-.141 1.441.365 2.855 1.389 3.878l8.305 8.305-12.352 12.352c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586l12.352-12.352 8.141 8.141c.911.909 2.131 1.41 3.404 1.41.157 0 .316-.008.475-.023 1.402-.137 2.651-.879 3.427-2.035 3.081-4.597 3.942-10.362 2.391-15.661l3.265-3.265c3.655.133 7.139-1.238 9.731-3.831 1.863-1.863 1.864-4.896 0-6.762zm-2.828 3.934c-1.965 1.965-4.684 2.914-7.454 2.611-.599-.065-1.203.146-1.632.574l-4.781 4.781c-.553.553-.732 1.376-.462 2.108 1.639 4.424 1.059 9.389-1.552 13.281-.139.207-.345.269-.493.282-.119.019-.414.013-.662-.234l-19.274-19.272c-.246-.247-.247-.545-.235-.661.015-.148.075-.355.283-.494 2.432-1.631 5.282-2.47 8.159-2.47 1.727 0 3.463.303 5.122.917.733.269 1.556.092 2.108-.462l4.78-4.78c.429-.429.64-1.029.574-1.632-.304-2.773.648-5.49 2.611-7.453.305-.305.801-.306 1.105 0l11.8 11.8c.305.305.306.801 0 1.105z" />
      </svg>
    </SvgIcon>
  );
};

export default PinIcon;
